export type Audience = "adults" | "children";

export const getPersonalSourcesRoutes = (audience: Audience) => {
  const basePath = `/${audience}/exercises/personal-sources`;

  return {
    index: basePath,
    step: (stepId: string) => `${basePath}/${stepId}`,
    sessions: `${basePath}/sessions`,
    summary: (sessionId: string) => `${basePath}/summary/${sessionId}`,
    end: `${basePath}/end`,
    backToExercises: `/${audience}/exercises`,
  };
};

export const getPreviousStepRoute = (
  currentId: string,
  audience: Audience
): string | null => {
  if (currentId === "1") {
    return getPersonalSourcesRoutes(audience).index;
  }

  const currentNum = parseInt(currentId);
  if (isNaN(currentNum) || currentNum <= 1) return null;

  return getPersonalSourcesRoutes(audience).step(`${currentNum - 1}`);
};
